/* eslint-disable react/no-multi-comp */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { translate } from 'services/i18nService';
import Button from 'components/Button/Button';
import { generateID } from 'utils/helpers';

import iconDone from '../../../images/icon-done.png';
import iconError from '../../../images/icon-error.png';

import styles from './ForumPayConfirmModal.css';


const TRANSACTION_STATUS = {
  CANCELLED: 'CANCELLED',
  PAID: 'PAID',
  FAILED: 'FAILED',
};

const IDs = {
  prefix: 'WR8wK8Oz',
  element: 'forumPayConfirmModal',
  cancelButton: 'cancelButton',
  copyAddressBtn: 'copyAddressBtn',
  copyAmountBtn: 'copyAmountBtn',
};
const makeId = generateID(IDs.prefix, IDs.element);

function ForumPayConfirmModal(props) {
  const { cryptoPurchaseStatus, data, resetFlow } = props;

  const {
    details,
    nextStage: { parameters },
  } = data;

  const purchaseSuccess = cryptoPurchaseStatus === TRANSACTION_STATUS.PAID;
  const purchaseError = (
    cryptoPurchaseStatus === TRANSACTION_STATUS.CANCELLED ||
    cryptoPurchaseStatus === TRANSACTION_STATUS.FAILED
  );

  const contentClasses = classnames({
    [styles.imageWrapper]: true,
    [styles.fadeIn]: Boolean(cryptoPurchaseStatus),
  });

  const successDisplay = () => (
    <Fragment>
      <img
        alt="Success icon"
        className={styles.messageImg}
        src={iconDone}
      />
      <p>{translate('payment.payment.successful.default')}</p>
    </Fragment>
  );

  const errorDisplay = () => (
    <Fragment>
      <img
        alt="Error icon"
        className={styles.messageImg}
        src={iconError}
      />
      <p>{translate('v2profile.notification.error.default')}</p>
    </Fragment>
  );

  const qrCodeDisplay = () => (
    <Fragment>
      <img alt="qr" src={parameters.qr_img} />
      <p>{translate('payment.forumpay.qr.code.warning')}</p>
    </Fragment>
  );

  return (
    <div className={styles.confirmModal}>
      <h2>{translate('payment.confirm.purchase')}</h2>
      <div className={styles.content}>
        <div className={styles.paymentInfo}>
          <span>{translate('payment.payment.id')}</span>
          <span>{parameters.payment_id}</span>
        </div>
        <div className={styles.paymentInfo}>
          <span>{translate('payment.reference.number')}</span>
          <span>{details.purchaseId}</span>
        </div>

        <ul>
          <li>
            <span>{translate('cam4bucks.cam4bucks.amount')}:</span>
            <span>
              {details.amount} {details.currency}
            </span>
          </li>
          <li>
            <span>{translate('payment.forumpay.recipient.address')}</span>
            <span>
              <CopyToClipboard text={parameters.address}>
                <Button
                  colour="white"
                  id={makeId(IDs.copyAddressBtn)}
                  label={translate('payment.forumpay.copy.to.clipboard')}
                />
              </CopyToClipboard>
            </span>
          </li>
          <li>
            <span>
              {translate(
                'payment.forumpay.amount.in.crypto',
                { 0: parameters.currency }
              )}
            </span>
            <span>
              <CopyToClipboard text={parameters.amount}>
                <Button
                  colour="white"
                  id={makeId(IDs.copyAmountBtn)}
                  label={translate('payment.forumpay.copy.to.clipboard')}
                />
              </CopyToClipboard>
            </span>
          </li>
          <li>
            <span>{translate('payment.payment.rate')}</span>
            <span>
              1 {parameters.currency} = {parameters.rate} {parameters.invoice_currency}
            </span>
          </li>
          <li>
            <span>{translate('payment.processing.fee')}</span>
            <span>
              {parameters.network_processing_fee} {parameters.currency}
            </span>
          </li>
          <li>
            <span>{translate('tipping.tipping.Total')}:</span>
            <span>
              {parameters.amount} {parameters.currency}
            </span>
          </li>
        </ul>
        <div className={contentClasses}>
          {!cryptoPurchaseStatus && qrCodeDisplay()}
          {purchaseError && errorDisplay()}
          {purchaseSuccess && successDisplay()}
        </div>
        <div className={styles.paymentInfo}>
          <span>{translate('payment.set.wallet.fee')}</span>
          <span>
            {parameters.fast_transaction_fee} {parameters.fast_transaction_fee_currency}
          </span>
        </div>
        <div className={styles.paymentInfo}>
          <span>{translate('payment.time.to.confirm')}</span>
          <span>
            <strong>{parameters.wait_time}</strong>
          </span>
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          colour="transparent"
          id={makeId(IDs.cancelButton)}
          label={translate('account.button.close')}
          onClick={resetFlow}
        />
      </div>
    </div>
  );
}

ForumPayConfirmModal.propTypes = {
  data: PropTypes.object.isRequired,
  resetFlow: PropTypes.func.isRequired,
  cryptoPurchaseStatus: PropTypes.oneOf([PropTypes.string, PropTypes.object]),
};

ForumPayConfirmModal.defaultProps = { cryptoPurchaseStatus: undefined };

export default ForumPayConfirmModal;
